import {
  getFiltersApi,
  getTabularDataApi,
  getAggregatedScoreApi,
  getTimelineApi,
  getTopNResultsApi,
  getExpandedTabularDataApi,
  getEngagementCountApi,
} from 'api/analytics/engagement';

import { getCohortKeyValues as getCohortKeyValuesReview } from 'services/analytics/review';

import { GroupByKeys, AggregatedScore } from './reviewHelper';

export const getFilters = () =>
  getFiltersApi().then((res) => ({
    ...res.entity,
    // cohorts: res.entity.cohort.map( ch => Cohort.fromJSON(ch)),
    cohorts: res.entity.cohort,
    groupByKeys: res.entity.groupByKeys.map((key) => GroupByKeys.fromJSON(key)),
    splitByKeys: res.entity.splitByKeys || [],
    sources: res.entity.source,
  }));

export const getAggregatedScore = ({ cohort, groupByKeys, splitByKeys, source, dateRange, parentUuid }) =>
  getAggregatedScoreApi({
    cohort,
    groupByKeys,
    splitByKeys,
    source,
    dateRange,
    parentUuid,
  }).then((res) => {
    if (splitByKeys.keyName === 'none') {
      return res.entity.map((json) => AggregatedScore.fromJSON(json));
    }
    return res.entity;
  });

/**
 * @deprecated 06-08-2024
 */
export const getHighestRatedCohorts = ({
  cohort,
  groupByKeys,
  splitByKeys,
  source,
  orderType = 'DESC',
  limit = 3,
  dateRange,
}) => {
  const orderBy = [
    {
      columnId: 'GOAL_PROGRESS_PERCENTAGE',
      orderType,
    },
  ];
  return getTopNResultsApi({
    cohort,
    groupByKeys,
    splitByKeys,
    source,
    orderBy,
    limit,
    dateRange,
  }).then((res) => res.entity);
};

export const getTabularData = ({ cohort, groupByKeys, splitByKeys, source, parentUuid, orderBy, dateRange }) => {
  if (orderBy?.columnId === null) orderBy = null;
  else orderBy = orderBy;

  return getTabularDataApi({
    cohort,
    groupByKeys,
    splitByKeys,
    source,
    parentUuid,
    orderBy,
    dateRange,
  }).then((res) => res.entity);
};

export const getExpandedTabularData = ({
  cohort,
  groupByKeys,
  splitByKeys,
  source,
  parentUuid,
  orderBy,
  dateRange,
}) => {
  if (orderBy?.columnId === null) orderBy = null;
  else orderBy = orderBy;

  return getExpandedTabularDataApi({
    cohort,
    groupByKeys,
    splitByKeys,
    source,
    parentUuid,
    orderBy,
    dateRange,
  }).then((res) => res.entity);
};

export const getCohortKeyValues = () => getCohortKeyValuesReview('ENGAGEMENT');

export const getTimelineData = ({ cohort, groupByKeys, splitByKeys, source, parentUuid, dateRange }) =>
  getTimelineApi({ cohort, groupByKeys, splitByKeys, source, parentUuid, dateRange }).then((res) => res.entity);

export const getEngagementCount = () => getEngagementCountApi({}).then((res) => res.entity);
